import { createSlice } from "@reduxjs/toolkit";
import { GPT_SEARCH } from "../utils/constants";

const appSlice = createSlice({
  name: "app",
  initialState: {
    user: null,
    navBtnText: GPT_SEARCH,
  },
  reducers: {
    addUser(state, action) {
      state.user = action.payload;
    },
    removeUser(state) {
      state.user = null;
    },
    updateNavBtnText(state, action) {
      state.navBtnText = action.payload;
    },
  },
});

export const { addUser, removeUser, updateNavBtnText } = appSlice.actions;
export default appSlice.reducer;
